import React, { useCallback, useState } from 'react';
import { useIntl } from 'react-intl';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShareNodes } from '@fortawesome/pro-light-svg-icons/faShareNodes';
import { TypedMemo } from '../../../common/types';
import { useSMLDatePickerDateParam } from '../../hooks/useSMLDatePickerDateParam';
import { SharePubliclyModal } from './SharePubliclyModal';

interface SharePubliclyButtonProps {
  type: 'artist' | 'track' | 'playlist';
  id: string;
  shareTitle: string;
  /** Entity name for the preview card (defaults to `shareTitle`). */
  name?: string;
  /** Cover image for the preview card. */
  coverUrl?: string;
  /** Secondary line under the name in the preview card. */
  subtitle?: string;
}

const SharePubliclyButtonComponent: React.FC<SharePubliclyButtonProps> = ({
  type,
  id,
  shareTitle,
  name,
  coverUrl,
  subtitle,
}) => {
  const intl = useIntl();
  const { selectedDateValue, rangeDays } = useSMLDatePickerDateParam();
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = useCallback(() => {
    setIsOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <>
      <Button color="primary" outline onClick={handleOpen} className="d-flex align-items-center gap-2">
        <FontAwesomeIcon icon={faShareNodes} />
        {intl.formatMessage({
          id: 'app.sml.sharePublicly.button',
          defaultMessage: 'Share Publicly',
        })}
      </Button>
      <SharePubliclyModal
        isOpen={isOpen}
        onClose={handleClose}
        type={type}
        id={id}
        date={selectedDateValue}
        rangeDays={rangeDays}
        shareTitle={shareTitle}
        name={name}
        coverUrl={coverUrl}
        subtitle={subtitle}
      />
    </>
  );
};

export const SharePubliclyButton = TypedMemo(SharePubliclyButtonComponent);
